/*
PURPOSE: Single source for the public-data contribution-report S3 URL (stage-aware).
USE CASES:
- The /trust financial-transparency view, the ecosystem genre view, and the
  artist payout checker all read the public, buyer-anonymous contribution report
  from the stage's public bucket.
DOMAIN BOUNDARIES:
- URL construction only. No fetch, no parse, no auth.
ASSUMPTIONS:
- Stage comes from REACT_APP_ENVIRONMENT (defaults to 'dev'). Each stage's bucket
  holds its own contribution report, so the URL must not be pinned to prod.
*/

const publicDataStage = (): string => process.env.REACT_APP_ENVIRONMENT || 'dev';

/** The public, buyer-anonymous contribution report (coral contributions + ticket fee-shares). */
export const getContributionReportCsvUrl = (): string =>
  `https://wearecoral-public-data-${publicDataStage()}.s3.ap-southeast-2.amazonaws.com/wearecoral-contribution-report.csv`;
